import { Form, TimePicker } from "antd";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { DATE_TIME_FORMAT } from "@lhd/constants";
import dayjs from "dayjs";
import { Styles } from "./styled";
import { getRuleValidation } from "@lhd/components/CloneApp/fieldUtils";
interface IProps {
  item: AppPartType;
  namePath: string | string[];
}

const TimeCustom = (props: IProps) => {
  const { namePath, item } = props;
  return (
    <Styles>
      <Form.Item
        name={namePath}
        rules={getRuleValidation(item)}
        getValueProps={(value) => ({
          value: value ? dayjs(value, DATE_TIME_FORMAT.DATE_TIME) : null,
        })}
        getValueFromEvent={(date) =>
          date ? date.format(DATE_TIME_FORMAT.DATE_TIME) : null
        }
      >
        <TimePicker format={DATE_TIME_FORMAT.TIME} />
      </Form.Item>
    </Styles>
  );
};
export default TimeCustom;
